import { motion } from "framer-motion";
import { Check, X, Minus } from "lucide-react";

const ROWS = [
    { feature: "Truck-legal routing & clearances", us: "yes", garmin: "yes", tp: "yes" },
    { feature: "Live weigh-station bypass alerts", us: "yes", garmin: "no", tp: "yes" },
    { feature: "Diesel price comparison", us: "yes", garmin: "no", tp: "yes" },
    { feature: "Parking occupancy radar", us: "yes", garmin: "no", tp: "partial" },
    { feature: "CB radio community mesh", us: "yes", garmin: "no", tp: "no" },
    { feature: "HOS clock + ELD sync", us: "yes", garmin: "partial", tp: "yes" },
    { feature: "Offline maps for dead zones", us: "yes", garmin: "yes", tp: "partial" },
    { feature: "Free for individual drivers", us: "yes", garmin: "no", tp: "no" },
];

const Mark = ({ v }) =>
    v === "yes" ? (
        <Check className="mx-auto h-5 w-5 text-[#2E7D32]" strokeWidth={3} />
    ) : v === "no" ? (
        <X className="mx-auto h-5 w-5 text-[#8C8377]" strokeWidth={3} />
    ) : (
        <Minus className="mx-auto h-5 w-5 text-[#FF8F00]" strokeWidth={3} />
    );

export default function Compare() {
    return (
        <section id="compare" data-testid="compare-section" className="relative px-6 pb-24 lg:px-16 lg:pb-32">
            <div className="mx-auto max-w-7xl">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                >
                    <p className="font-mono2 text-xs font-bold tracking-[0.35em] text-[#E5A93C]">
                        HEAD-TO-HEAD — THE OLD GUARD VS THE NEW SHERIFF
                    </p>
                    <h2 className="font-display mt-4 text-4xl uppercase tracking-wide text-[#F6F2E8] sm:text-5xl md:text-6xl">
                        WHY DRIVERS <span className="text-[#D32F2F]">SWITCH LANES</span>
                    </h2>
                    <div className="hazard mt-6 h-3 w-40 border-2 border-[#0E0D0C]" />
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
                    className="mt-14 overflow-x-auto"
                >
                    <table
                        data-testid="compare-table"
                        className="w-full min-w-[680px] border-2 border-[#0E0D0C] shadow-[8px_8px_0px_#0E0D0C]"
                    >
                        <thead>
                            <tr className="bg-[#0E0D0C]">
                                <th className="font-mono2 border-b-2 border-[#0E0D0C] px-5 py-4 text-left text-xs font-bold tracking-[0.25em] text-[#8C8377]">
                                    CAPABILITY
                                </th>
                                <th className="font-display border-b-2 border-l-2 border-[#0E0D0C] bg-[#D32F2F] px-5 py-4 text-center text-lg tracking-widest text-[#F6F2E8]">
                                    PUT CHA FOOT IN IT
                                </th>
                                <th className="font-display border-b-2 border-[#0E0D0C] px-5 py-4 text-center text-lg tracking-widest text-[#8C8377]">
                                    GARMIN
                                </th>
                                <th className="font-display border-b-2 border-[#0E0D0C] px-5 py-4 text-center text-lg tracking-widest text-[#8C8377]">
                                    TRUCKER PATH
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {ROWS.map((r) => (
                                <tr
                                    key={r.feature}
                                    data-testid={`compare-row-${r.feature.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                                    className="border-t-2 border-[#24211E] bg-[#161413] transition-colors hover:bg-[#24211E]"
                                >
                                    <td className="font-mono2 px-5 py-4 text-xs font-bold tracking-wider text-[#F6F2E8] sm:text-sm">
                                        {r.feature}
                                    </td>
                                    <td className="border-l-2 border-[#0E0D0C] bg-[#D32F2F]/15 px-5 py-4 text-center">
                                        <Mark v={r.us} />
                                    </td>
                                    <td className="px-5 py-4 text-center">
                                        <Mark v={r.garmin} />
                                    </td>
                                    <td className="px-5 py-4 text-center">
                                        <Mark v={r.tp} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </motion.div>

                <p className="font-mono2 mt-6 text-[10px] tracking-[0.25em] text-[#8C8377]">
                    BASED ON PUBLISHED FEATURE LISTS, JULY 2026 — ✓ FULL ★ — PARTIAL ✕ NONE
                </p>
            </div>
        </section>
    );
}
